<template>
  <q-page>
    <div class="container row q-mt-lg col-12">
      <div
        style="font-size: 15px"
        class="text-brand-1 text-h6 text-center mensage-mobile"
      >
        Clique no icone
        <q-icon color="white" class="icon" name="menu"></q-icon>
        para navegar pelos Menus
      </div>

      <div
        class="text-h4 text-brand-1 text-bold esconder q-mb-xl content-wrapper"
      >
        Seja bem-vindo {{ dados.given_name }},
      </div>

      <!-- Banner Carousel de Novidades -->
      <div class="col-12 q-mb-lg">
        <BannerCarousel
          :key="bannerKey"
          :cliente="cliente"
          @banner-closed="onBannerClosed"
          @banner-action="onBannerAction"
        />
      </div>
    </div>
    <div v-if="!aceite && online">
      <Termo />
    </div>
  </q-page>
</template>

<script>
import { useRoute, useRouter } from "vue-router";
import { onMounted, inject, ref, watch, onUnmounted } from "vue";
import routes from "@/router/routes";
import { useStore } from "vuex";
import Termo from "../modules/termosDeUso/views/Termo.vue";
import { BannerCarousel } from "@/modules/banners";

export default {
  components: {
    Termo,
    BannerCarousel,
  },
  setup() {
    const router = useRouter();
    const route = useRoute();
    const online = ref(window.navigator.onLine);
    const store = useStore();
    const keycloak = inject("keycloak");
    const dados = ref("");
    const menuList = ref(routes[0].children);
    const activeBackOffice = ref([]);
    const cliente = store.state.autenticacao.cliente[0];
    let aceite = store.state.termo.aceite;

    // Chave para forçar recarregamento do BannerCarousel
    const bannerKey = ref(0);

    // Função para recarregar banners (chamada quando detecta reset)
    const reloadBanners = () => {
      bannerKey.value += 1;
    };

    // Detectar evento customizado de reset de banners
    const handleBannerReset = () => {
      reloadBanners();
    };

    // Funções para lidar com eventos dos banners de novidades
    const onBannerClosed = () => {
      // Aqui você pode adicionar lógica adicional se necessário
    };

    const onBannerAction = (actionData) => {
      switch (actionData.type) {
        case "navigate":
          router.push(actionData.route);
          break;
        case "function":
          // Executar funções personalizadas
          if (actionData.function === "openSupport") {
            // Exemplo: abrir modal de suporte
            // Aqui você pode implementar a lógica específica
          }
          break;
        default:
          break;
      }
    };

    const configurarPt = (value) => {
      localStorage.setItem("tab", value.meta.label);
      sessionStorage.menu = JSON.stringify(value.children);
      let rota = value.children.find((e) => {
        if (!e.meta.permission) {
          return e.name;
        }
      });
      localStorage.setItem("subTab", rota.name);

      router.push({ name: rota.name });
    };

    const hiddenTab = async () => {
      dados.value = keycloak.idTokenParsed;
    };

    const getModules = async () => {
      try {
        let response = await store.dispatch("autenticacao/getModulosCliente", {
          type: "termo",
        });

        response.data.resultado.dados.forEach((e) => {
          activeBackOffice.value.push(e.nome);
        });

        let resultado = menuList.value.filter((e) => {
          if (e.children) {
            return activeBackOffice.value.indexOf(e.meta.label) == -1;
          }
        });

        resultado.forEach((desativos) => {
          let indice = menuList.value.indexOf(desativos);

          menuList.value.splice(indice, 1);
        });
      } catch (error) {
        console.log(error);
      }
    };

    watch(
      () => route.name,
      (newRouteName, oldRouteName) => {
        localStorage.setItem("tab", route.matched[1]?.meta?.label);
        localStorage.setItem("subTab", route.matched[1]?.children[0]?.name);

        // Se chegamos na home vindo de outra rota, força recarregamento dos banners
        if (
          newRouteName === "home" &&
          oldRouteName &&
          oldRouteName !== "home"
        ) {
          setTimeout(() => {
            reloadBanners();
          }, 100);
        }
      }
    );

    onMounted(hiddenTab);
    onMounted(getModules);

    // Adicionar listener para evento customizado de reset de banners
    onMounted(() => {
      window.addEventListener("banner-reset", handleBannerReset);
    });

    // Remover listener ao desmontar
    onUnmounted(() => {
      window.removeEventListener("banner-reset", handleBannerReset);
    });

    return {
      configurarPt,
      menuList,
      hiddenTab,
      dados,
      getModules,
      activeBackOffice,
      aceite,
      online,
      cliente,
      // Banner Carousel controls
      bannerKey,
      onBannerClosed,
      onBannerAction,
    };
  },
};
</script>

<style scoped>
.mensage-mobile {
  display: none;
}
.container {
  width: 90%;
  margin: 0 auto;
  justify-content: center;
  padding-top: 50px;
  padding-bottom: 10px;
  min-height: 100% !important;
}

.content-wrapper {
  width: 100%;
  text-align: left;
  padding-left: 12.5%;
}

.animacao {
  transition: all 0.5s;
}
.animacao:hover {
  -webkit-transform: scale(1.1);
  -ms-transform: scale(1.1);
  transform: scale(1.1);
}

.padding {
  margin: 0 auto;
  padding-top: 54px;
}

.bg1 {
  background-color: #17d48f !important;
}

.bg2 {
  background-color: #151f6b !important;
}

.bg3 {
  background-color: #e23431 !important;
}

.bg4 {
  background-color: #6ab3bf !important;
}

.bg5 {
  background-color: #21459e !important;
}

.bg6 {
  background-color: #2ab2c9 !important;
}

.width1 {
  background-color: #2ab2c9 !important;
}

.size {
  font-size: 20px;
}

@media (max-width: 1211px) {
  .padding {
    padding-top: 40px !important;
  }

  .container {
    width: 95%;
    margin: 0 auto;
    justify-content: center;
    padding-top: 20px;
    padding-bottom: 20px;
  }

  .content-wrapper {
    padding-left: 5%;
  }

  .width1 {
    width: 26% !important;
  }

  .size {
    font-size: 16px;
  }

  .mobile .column {
    height: 150px !important;
  }

  .mobile .label {
    padding-top: 0px;
  }
}
@media (max-width: 838px) {
  .padding {
    padding-top: 20px !important;
  }
  .animacao:hover {
    -webkit-transform: scale(1);
    -ms-transform: scale(1);
    transform: scale(1);
  }

  .container {
    width: 95%;
    margin: 0 auto;
    justify-content: center;
    padding-top: 20px;
    padding-bottom: 20px;
  }

  .resp {
    width: 92% !important;
    flex-grow: 1;
  }

  .resp2 {
    width: 44% !important;
    flex-grow: 1;
  }

  .mensage-mobile {
    display: block;
  }

  .icon {
    background-color: #213864;
  }
  .size {
    font-size: 13px;
  }

  .esconder {
    font-size: 24px;
  }

  .mobile .column {
    height: 150px !important;
  }

  .mobile .label {
    padding-top: 0px;
  }
}
@media (max-width: 300px) {
  .padding {
    padding-top: 20px !important;
  }
  .animacao:hover {
    -webkit-transform: scale(1);
    -ms-transform: scale(1);
    transform: scale(1);
  }

  .container {
    width: 98%;
    margin: 0 auto;
    justify-content: center;
    padding-top: 20px;
    padding-bottom: 20px;
  }

  .resp {
    width: 92% !important;
    flex-grow: 1;
  }

  .resp2 {
    width: 44% !important;
    flex-grow: 1;
  }

  .esconder {
    display: none;
  }

  .size {
    font-size: 13px;
  }

  .mobile .column {
    height: 150px !important;
  }

  .mobile .label {
    padding-top: 0px;
  }
}
</style>
